import { Renderer_Order } from './Renderer_Order.js';
import { _className, stopPropagation } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { ModuleFE_ProvideInfo } from '../../../../modules/provide-info/ModuleFE_ProvideInfo.js';
export class Renderer_Order_InputRequired extends Renderer_Order {
    __onReadOnlyChanged() {
        this.reDeriveState();
    }
    deriveStateFromProps(nextProps, state) {
        state.protocolData = nextProps.protocolData;
        state.disabled = ModuleFE_EMInterface.isReadonly();
        return state;
    }
    onOrderClick = async (e) => {
        stopPropagation(e);
        if (this.state.disabled)
            return;
        const data = this.state.protocolData;
        ModuleFE_ProvideInfo.protocol.open(data.protocol._id, true);
    };
    getOrderIcon = undefined;
    getOrderLabel = () => {
        return 'Provide Info';
    };
    getOrderClass = () => {
        return _className(super.getOrderClass(), 'input-required');
    };
    getVariant = () => 'primary';
}
//# sourceMappingURL=Renderer_Order_InputRequired.js.map